// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"_93444fe79c--breadcrumbs--3q1Ip","breadcrumbs-link":"_93444fe79c--breadcrumbs-link--alEvq","breadcrumbs-delimiter":"_93444fe79c--breadcrumbs-delimiter--g4eTj"};